import { createSelector } from '@reduxjs/toolkit';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import { ObjectOfAny } from '../reducers/types';
import { RootState } from '../store/store';
import codes from '../utils/constants/codes';

const claimDocumentProjections = {} as ObjectOfAny;

type ClaimDocument = {
    id: string;
    fullFileName: string;
    createdDate: string;
    fullName: string;
    documentTypes: any;
};

claimDocumentProjections.documentList = createSelector(
    (state: RootState) => state.claimDocument.claimDocument.byId,
    (state: RootState) => state.applicationSettings.apiApplicationSettings,
    (claimDocumentById, apiApplicationSettings) => {
        if (!claimDocumentById || !apiApplicationSettings) {
            return [];
        }
        let anonymisedFields =
            apiApplicationSettings?.anonymisedFields &&
            apiApplicationSettings?.anonymisedFields[
                codes.anonymisedCodes.Attachments
            ]
                ? apiApplicationSettings?.anonymisedFields[
                      codes.anonymisedCodes.Attachments
                  ][codes.Attachment]
                : [];

        return Object.values(claimDocumentById as ClaimDocument).map(
            claimDocument => ({
                fullName: claimDocument.createdBy.fullName,
                createdDate: GENERAL_FUNCTIONS.dateFormat(
                    claimDocument.createdDate,
                ),
                id: claimDocument.id,
                fullFileName:
                    claimDocument.isAnonymised &&
                    anonymisedFields.includes(
                        GENERAL_FUNCTIONS.capitalizeFirstLetter(
                            codes.namesToDecode.filename,
                        ),
                    )
                        ? codes.Anonymised
                        : claimDocument.fullFileName,
                documentTypes:
                    claimDocument.documentTypes &&
                    claimDocument.documentTypes.length > 0
                        ? ' ' +
                          '(' +
                          claimDocument.documentTypes
                              .map((item: { name: string }) => item.name)
                              .join(',') +
                          ')'
                        : '',
            }),
        );
    },
);

claimDocumentProjections.claimDocumentLoader = createSelector(
    (state: RootState) => state.claimDocument,
    claimDocumentLoader => {
        return claimDocumentLoader.loading;
    },
);

export default claimDocumentProjections;
